import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=6b8c229a&scoped=true"
import script from "./FrontPage.vue?vue&type=script&lang=js"
export * from "./FrontPage.vue?vue&type=script&lang=js"
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=6b8c229a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c229a",
  null
  
)

export default component.exports